<template>
  <v-app id="app">

    <CoreNavigation v-if="isLogin" ref="CoreNavigationRef"/>
    <CoreView />

    <MsgBar ref="MsgBarRef" />
    <MsgBox ref="MsgBoxRef" />
   </v-app>
</template>

<script>
import CoreView from "@/components/core/View.vue";
import CoreNavigation from "@/components/core/Navigation.vue";

import MsgBar from "@/components/MsgBar.vue";
import MsgBox from "@/components/MsgBox.vue";
import EventBus from '@/eventBus.js';
import {mapState} from "vuex";
import Vuetify from 'vuetify/lib';

Vuetify.config.silent = true;

window.onkeydown = function() {
	var kcode = event.keyCode;
	if(kcode == 116) event.returnValue = false;
}

export default {
  name: 'App',
  components: {
    CoreView,
    CoreNavigation,
    MsgBar,
    MsgBox,
  },
  
  data: () => ({
  }),
  
  computed: {
    ...mapState(["isLogin"]),
  },

  created() {
    this.$vuetify.theme.dark = false;

    // window.addEventListener('beforeunload', () => {
    //   this.$store.dispatch('logout');
    //   return null
    // })
  },

  mounted() {
    EventBus.$on("onShowMsg2", (sTitle, sMsg) => {
      this.$refs.MsgBoxRef.RunMsgBoxShow2(sTitle, sMsg);
    });
    EventBus.$on("onShowMsg", (result, data) => {
      this.$refs.MsgBarRef.ShowMsg(result, data);
    });
    EventBus.$on("onShowMsgBox", (sTitle, sMsg) => {
      this.$refs.MsgBarRef.RunMsgBoxShow(sTitle, sMsg);
    });
    EventBus.$on("onGoChangeImg", (APIURL, Path) => {
      this.$refs.CoreNavigationRef.ChangeImg(APIURL, Path);
    });
    EventBus.$on("onTokenExpired", () => {
      this.$store.dispatch('logout',"onTokenExpired");
      this.$refs.MsgBarRef.RunMsgBoxShow("로그인 한지 30분이 넘었습니다.", "다시 로그인하여 주세요.");
    });
    EventBus.$on("onChangeCorpInfo", () => {
      this.$store.dispatch('logout',"onChangeCorpInfo");
      this.$refs.MsgBarRef.RunMsgBoxShow("소속 업체가 변경 되었습니다.", "다시 로그인 하여 주세요.");
    });
    EventBus.$on("onChangeManager", () => {
      this.$refs.MsgBarRef.RunMsgBoxShow("관리자 정보가 변경 되었습니다.", "자세한 사항의 업체정보 정정신청 화면에서 확인 하거나 해당 업체에 문의하여 주세요.");
    });
    EventBus.$on("onDelCustomInfo", () => {
      this.$store.dispatch('logout',"onDelCustomInfo");
      this.$refs.MsgBarRef.RunMsgBoxShow("삭제된 아이디입니다.", "다시 로그인 하여 주세요.");
    });
    // EventBus.$on("onSetionLoout", () => {
    //   this.$store.dispatch('logout',"onSetionLoout");
    //   this.$refs.MsgBarRef.RunMsgBoxShow("로그인 한지 30분이 넘었습니다.", "다시 로그인하여 주세요.");
    // });
    EventBus.$on("onFileBus", () => {
    });
    EventBus.$on("onRoute", (data) => {
      this.$router.push({name: data});
    });
  },

  beforeDestroy(){
    // window.removeEventListener('beforeunload');
    EventBus.$off('onShowMsg2');
    EventBus.$off('onShowMsg');
    EventBus.$off('onShowMsgBox');
    EventBus.$off('onGoChangeImg');
    EventBus.$off('onTokenExpired');
    // EventBus.$off('onSetionLoout');
    EventBus.$off('onChangeCorpInfo');
    EventBus.$off('onChangeManager');
    EventBus.$off('onDelCustomInfo');
    EventBus.$off('onFileBus');
    EventBus.$off('onRoute');
  },
};
</script>


<style>
  input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  .essetial_card {
    background-color : #F2F2F2 !important;
    /* background : red !important; */
  }
  
  .essetial_calendar {
    background-color : #F2F2F2 !important;
    /* background : red !important; */
  }

  /* .essetial_card {
    border-width: 1px !important;
    border-color: black !important;
  } */
  
  /* .essetial_input .v-text-field__slot {
    background-color: #F1F3F4 !important;
  } */

  /* .essetial_input .v-select__selections {
    background-color: #F1F3F4 !important;
  } */

  /* 밑줄 긋기 */
  .word_keeper {
    word-break: keep-all;
  }
  /* 밑줄 긋기 */
  .custom_style {
    border-bottom: 2px solid #757575;
    font-size: 16px;
    background: #EEEEEE;
  }

  .heartbeat {
    -webkit-animation: heartbeat 3s ease-in-out infinite both;
            animation: heartbeat 3s ease-in-out infinite both;
  }
  
  @-webkit-keyframes heartbeat {
    from {
      -webkit-transform: scale(1);
              transform: scale(1);
      -webkit-transform-origin: center center;
              transform-origin: center center;
      -webkit-animation-timing-function: ease-out;
              animation-timing-function: ease-out;
    }
    5% {
      -webkit-transform: scale(0.91);
              transform: scale(0.91);
      -webkit-animation-timing-function: ease-in;
              animation-timing-function: ease-in;
    }
    8% {
      -webkit-transform: scale(0.98);
              transform: scale(0.98);
      -webkit-animation-timing-function: ease-out;
              animation-timing-function: ease-out;
    }
    16% {
      -webkit-transform: scale(0.87);
              transform: scale(0.87);
      -webkit-animation-timing-function: ease-in;
              animation-timing-function: ease-in;
    }
    22% {
      -webkit-transform: scale(1);
              transform: scale(1);
      -webkit-animation-timing-function: ease-out;
              animation-timing-function: ease-out;
    }
  }
  @keyframes heartbeat {
    from {
      -webkit-transform: scale(1);
              transform: scale(1);
      -webkit-transform-origin: center center;
              transform-origin: center center;
      -webkit-animation-timing-function: ease-out;
              animation-timing-function: ease-out;
    }
    5% {
      -webkit-transform: scale(0.91);
              transform: scale(0.91);
      -webkit-animation-timing-function: ease-in;
              animation-timing-function: ease-in;
    }
    8% {
      -webkit-transform: scale(0.98);
              transform: scale(0.98);
      -webkit-animation-timing-function: ease-out;
              animation-timing-function: ease-out;
    }
    16% {
      -webkit-transform: scale(0.87);
              transform: scale(0.87);
      -webkit-animation-timing-function: ease-in;
              animation-timing-function: ease-in;
    }
    22% {
      -webkit-transform: scale(1);
              transform: scale(1);
      -webkit-animation-timing-function: ease-out;
              animation-timing-function: ease-out;
    }
  }

  .slide-top {
    -webkit-animation: slide-top 1s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
    animation: slide-top 1s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
  }

  @-webkit-keyframes slide-top {
    0% {
      -webkit-transform: translateY(100px);
              transform: translateY(100px);
      opacity: 0;
    }
    100% {
      -webkit-transform: translateY(0);
              transform: translateY(0);
      opacity: 1;
    }
  }
  @keyframes slide-top {
    0% {
      -webkit-transform: translateY(100px);
              transform: translateY(100px);
      opacity: 0;
    }
    100% {
      -webkit-transform: translateY(0);
              transform: translateY(0);
      opacity: 1;
    }
  }

  .slide-left {
    -webkit-animation: slide-left 1s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
    animation: slide-left 1s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
  }

  @-webkit-keyframes slide-left {
    0% {
      -webkit-transform: translateX(-100px);
              transform: translateX(-100px);
      opacity: 0;
    }
    100% {
      -webkit-transform: translateX(0);
              transform: translateX(0);
      opacity: 1;
    }
  }
  @keyframes slide-left {
    0% {
      -webkit-transform: translateX(-100px);
              transform: translateX(-100px);
      opacity: 0;
    }
    100% {
      -webkit-transform: translateX(0);
              transform: translateX(0);
      opacity: 1;
    }
  }

  /* .fade-in-bottom {
    -webkit-animation: fade-in-bottom 3s cubic-bezier(0.390, 0.575, 0.565, 1.000) 10 alternate;
            animation: fade-in-bottom 3s cubic-bezier(0.390, 0.575, 0.565, 1.000) 10 alternate;
  } */
  .fade-in-bottom {
    -webkit-animation: fade-in-bottom 5s cubic-bezier(0.390, 0.575, 0.565, 1.000) 5 ;
            animation: fade-in-bottom 5s cubic-bezier(0.390, 0.575, 0.565, 1.000) 5 ;
  }

  @-webkit-keyframes fade-in-bottom {
    0% {      
      opacity: 0.33;
    }
    30% {      
      opacity: 0.15;
    }
    80% {      
      opacity: 0.45;
    }
    100% {
      opacity: 0.33;
    }
  }
  @keyframes fade-in-bottom {
    0% {      
      opacity: 0.33;
    }
    30% {      
      opacity: 0.15;
    }
    80% {      
      opacity: 0.45;
    }
    100% {
      opacity: 0.33;
    }
    /* 0% {      
      opacity: 0.05;
    }
    100% {
      opacity: 0.33;
    } */
  }

  .main_back {
    background: linear-gradient(to top, #444444, 10%, rgb(255, 255, 255));
    /* background: linear-gradient( to top, yellow, red ); */
    height: 100vh;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
  }
  .main_bottom {
    z-index: 0;
    position: fixed;
    left:0;
    top:30vh;    
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
    /* background:red; */
    opacity: 0.33;
    overflow: hidden;
    background: linear-gradient(to top, #444444, 10%, rgb(255, 255, 255));
  }

  .v-application {
    /* font-family: 'Spoqa Han Sans Neo', 'sans-serif' !important; */
    font-family: 'Noto Sans KR', 'sans-serif' !important;
  }

  .v-application .text-subtitle-1, .v-application .subtitle-2, .v-application .caption   {
    /* font-family: 'Spoqa Han Sans Neo', 'sans-serif' !important; */
    font-family: 'Noto Sans KR', 'sans-serif' !important;
  }
  .v-application .text-h5, .v-application .text-h4{
    /* font-family: 'Spoqa Han Sans Neo', 'sans-serif' !important; */
    font-family: 'Noto Sans KR', 'sans-serif' !important;
  }

  .v-data-table-header__icon{
    position: relative;
    width: 0px;
    left: 10px;
  }
  .main_image {
    z-index: 0;
    position: fixed;
    width: 100%;
    overflow: hidden;
    object-fit: cover;
    background-position: center;
    /* background: #96988E; */
  }

  .table_div { 
    height:5px; 
    background:#FAFAFA;
  }

  
  [role=columnheader] {
    white-space: nowrap;
  }

  td.text-center {
    border-bottom: 0.5px solid #E0E0E0 !important;
    -webkit-line-clamp: 1;
    text-overflow: ellipsis !important;
  }

  td.text-start {
    border-bottom: 0.5px solid #E0E0E0 !important;
    text-overflow: ellipsis !important;
  }

  td.text-end {
    border-bottom: 0.5px solid #E0E0E0 !important;
    text-overflow: ellipsis !important;
  }

  td.text-right {
    border-bottom: 0.5px solid #E0E0E0 !important;
    text-overflow: ellipsis !important;
  }

  td.text-left {
    border-bottom: 0.5px solid #E0E0E0 !important;
    text-overflow: ellipsis !important;
  }

  .un_use_item {
    color:#CCCCCC;
    text-decoration: line-through;     /* 글자중간에 줄긋기 */
    /* background-color: orange !important; */
  }

  .un_readed_item {
    color:#CCCCCC;
  }

  .un_unreaded_senderror_item {
    color:#FF0000;
  }

  .v-data-footer__select{
    height: 40px;
  }

  .v-data-table > .v-data-table__wrapper > table > tbody > tr > th,
  .v-data-table > .v-data-table__wrapper > table > thead > tr > th,
  .v-data-table > .v-data-table__wrapper > table > tfoot > tr > th {
    border-bottom: 2px solid #EEEEEE !important;
    /* border-bottom: 12px solid #eAeAeA !important; */
    font-size: 12px !important;
  }

  .v-data-table__wrapper{
    border-bottom: 1px solid #E0E0E0 !important;
    -webkit-line-clamp: 1;
  }

  .theme--light.v-data-table .v-data-footer {
    border-top: 0px solid red !important;
    -webkit-line-clamp: 1;
  }

  #AppHeader2 {
    z-index: 0;
    Height : 50px;
    width : 100%;
    background: white;
  }

  ::-webkit-scrollbar {
    width: 13px;           /* width of the entire scrollbar */
    height: 13px;
  }

  ::-webkit-scrollbar-track {
    /* background: rgb(122, 122, 122); */
    background:#F8F8F8;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #E8E8E8;    /* color of the scroll thumb */
    /* border: 2px solid orange;   */
    /* box-shadow: 0px 0px 10px #999999; */
  }

  .v-date-picker-table .v-btn {
    font-size: 13px !important;
  }

  /* Center.... */
  .iron_center_contents {
    display: flex;
    justify-content: center;
    align-items: center;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
  }


  .center_all {  
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .no-select {
    user-select: none; /* 기본적인 선택 방지 */
    -webkit-user-select: none; /* 크롬, 사파리 */
    -moz-user-select: none; /* 파이어폭스 */
    -ms-user-select: none; /* 인터넷 익스플로러 */
  }


/* 
  .make_scroll_class {
    overflow: auto;
    height: calc(90vh - 100px);
  } */
</style>

